'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Discretionary Serve information
 */
var DiscretionaryServe = function (_Component) {
  (0, _inherits3.default)(DiscretionaryServe, _Component);

  function DiscretionaryServe() {
    (0, _classCallCheck3.default)(this, DiscretionaryServe);
    return (0, _possibleConstructorReturn3.default)(this, (DiscretionaryServe.__proto__ || (0, _getPrototypeOf2.default)(DiscretionaryServe)).apply(this, arguments));
  }

  (0, _createClass3.default)(DiscretionaryServe, [{
    key: 'render',
    value: function render() {
      var eatForHealthImg = require('../Assets/eatforhealth.png');
      var styles = require('../../Modules.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'strong',
          { className: styles.orangeText },
          'A serve of discretionary choices provides about 500-600kJ:'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 6 },
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '2 scoops (75g) ice-cream'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '2 slices (50-60g) processed meats, salami or mettwurst'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 1/2 thick or 2 thin (50-70g) regular sausages'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/2 snack-size packet (30g) salt crackers or crisps'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '2-3 (35g) sweet plain biscuits'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 (40g) doughnut'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 slice (40g) plain cake/small cake-type muffin'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '5-6 (40g) sugar confectioanry/small lollies'
              )
            )
          )
        ),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 6 },
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 tbsp (60g) jam or honey'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/2 bar (25g) chocolate'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '2 tbsp (40g) cream'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 tbsp (20g) butter'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 can (375mL) soft drink (sugar-sweetened)'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/4 pie or pastes (60g) commercial meat pie or pastie (individual size)'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '12 (60g) fried hot chips'
              )
            )
          )
        ),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12 },
          _react2.default.createElement(
            'strong',
            null,
            'Suggested serving size for cake, small pie, thin sausages'
          ),
          _react2.default.createElement(ReactBootstrap.Image, { src: eatForHealthImg, className: styles.image40 + ' center-block', responsive: true })
        )
      );
    }
  }]);
  return DiscretionaryServe;
}(_react.Component);

exports.default = DiscretionaryServe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/DiscretionaryServe/DiscretionaryServe.js
// module id = 1263
// module chunks = 0